module.exports = __webpack_public_path__ + "media/images/about_publishing_hero-5f612d8d453f6d01594b11f3cec6d7cf.jpg";